import bp from "../style_variables/_breakpoints.scss";

export const useBreakPoints = () => {
  const sizeIsValid = (size) => Object.keys(bp).indexOf(size) !== -1;
  const deprecatedSizes = ["xs", "sm", "md", "lg", "xl", "xxl"];
  const sizeIsDeprecated = (size) => deprecatedSizes.indexOf(size) !== -1;
  const deprecationNotice = () =>
    console.warn(
      '[FC Warn]: usage of size helpers deprecated. Use use the "include-media" helpers instead.'
    );
  const InvalidSizeError = new Error(
    `[FC Error]: Invalid size arg provided. Expecting one of ${Object.keys(
      bp
    ).join(", ")}.`
  );

  const isXs = (containerWidth) => {
    deprecationNotice();
    return containerWidth < bp.sm;
  };
  const isSm = (containerWidth) => {
    deprecationNotice();
    return containerWidth >= bp.sm && containerWidth < bp.md;
  };
  const isMd = (containerWidth) => {
    deprecationNotice();
    return containerWidth >= bp.md && containerWidth < bp.lg;
  };
  const isLg = (containerWidth) => {
    deprecationNotice();
    return containerWidth >= bp.lg && containerWidth < bp.xl;
  };
  const isXl = (containerWidth) => {
    deprecationNotice();
    return containerWidth >= bp.xl && containerWidth < bp.xxl;
  };
  const isXxl = (containerWidth) => {
    deprecationNotice();
    return containerWidth >= bp.xxl;
  };

  const isAtLeast = (size, containerWidth) => {
    if (!sizeIsValid(size)) throw InvalidSizeError;
    if (sizeIsDeprecated(size)) deprecationNotice();

    return containerWidth >= bp[size];
  };

  const isBelow = (size, containerWidth) => {
    if (!sizeIsValid(size)) throw InvalidSizeError;
    if (sizeIsDeprecated(size)) deprecationNotice();

    return containerWidth < bp[size];
  };

  return {
    breakPoints: bp,
    isXs,
    isSm,
    isMd,
    isLg,
    isXl,
    isXxl,
    isBelow,
    isAtLeast,
  };
};
